<app-spinner></app-spinner>

<div class="container-fluid">
    <app-navbar></app-navbar>
</div>

<div class="container tabs-container">
    <app-nav-tabs></app-nav-tabs>
</div>

<div class="container main-content">

    <app-flash-messages></app-flash-messages>

    <div class="router-outlet-wrapper">
        <router-outlet></router-outlet>
    </div>

    <!--<app-terms-and-conditions></app-terms-and-conditions>-->
</div>

<div class="container-fluid">
    <app-footer></app-footer>
</div>
